// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AxC-E","label":"styles_label__6z0Ns"};